export const parse = (v) => Number(v.replace(/[^0-9.]/g, ''))